import {
  Ref, ref, computed, onMounted, watch,
} from 'vue';
import { useRoute } from 'vue-router';
import { message } from 'ant-design-vue';
import { useStore } from 'vuex';
import CustomQuery from '../models/CustomQuery';

export interface ResultUseCreateCustomQuery {
  loadingFetchDetail: Ref<boolean>;
  loadingSave: Ref<boolean>;
  errorMessageSave: Ref<string>;
  saveCustomQuery: (customQueryBody: CustomQuery) => Promise<void>;
  customQuery: Ref<any>;
}

export default function useUpdateQuery(): ResultUseCreateCustomQuery {
  const route = useRoute();
  const store = useStore();
  const projectSlug = computed(() => {
    const slugOrSlugs = route.params.slug;
    return Array.isArray(slugOrSlugs) ? slugOrSlugs[0] : slugOrSlugs;
  });

  const customQueryId = computed(() => {
    const slugOrSlugs = route.params.customQueryId;
    return Array.isArray(slugOrSlugs) ? slugOrSlugs[0] : slugOrSlugs;
  });

  const loadingSave = ref(false);
  const loadingFetchDetail = ref(false);
  const errorMessageSave = ref();
  const errorMessageFetchDetail = ref();
  const customQuery = ref();
  // const customQuery.value = find((item) => get('id', item) === customQueryId,  store.state.customQueries);

  const saveCustomQuery = async (customQueryBody: CustomQuery) => {
    loadingSave.value = true;
    errorMessageSave.value = null;

    const { data, error } = await store.dispatch('customQuery/updateCustomQuery', {
      customQueryId: customQueryId.value,
      customQuery: customQueryBody,
      projectSlug: projectSlug.value,
    });
    if (data) {
      customQuery.value = data;
      errorMessageSave.value = null;
      message.success('Update spreadsheet successfully');
    } else {
      customQuery.value = null;
      errorMessageSave.value = error;
      message.error('Update spreadsheet failed');
    }
    loadingSave.value = false;

    return data;
  };

  const fetchDetail = async () => {
    if (!customQueryId.value || !projectSlug.value) return;
    loadingFetchDetail.value = true;
    const { data, error } = await store.dispatch('customQuery/fetchCustomQueryDetail', {
      customQueryId: customQueryId.value,
      projectSlug: projectSlug.value,
    });
    if (data) {
      customQuery.value = data;
      errorMessageFetchDetail.value = null;
    } else {
      customQuery.value = null;
      errorMessageFetchDetail.value = error;
    }
    loadingFetchDetail.value = false;
  };

  onMounted(async () => {
    fetchDetail();
  });

  watch(customQueryId, async () => {
    fetchDetail();
  });

  return {
    loadingSave,
    errorMessageSave,
    saveCustomQuery,
    customQuery,
    loadingFetchDetail,
  };
}
